<div>
  <div class="sm:flex sm:items-center justify-between">
    <div class="sm:flex-auto">
      <h1 class="text-xl font-semibold text-gray-900">Blacklist USDC Wallets</h1>
      <p class="mt-2 text-xs text-gray-700">A list of all the users in your account including their name, title, email and role.</p>
    </div>

    <!-- Add Search Input -->
    <div class="flex items-center gap-4 mt-4 sm:mt-0">
      <div class="relative">
        <input
          type="text"
          placeholder="Search..."
          [(ngModel)]="searchQuery"
          (ngModelChange)="onSearchChange()"
          class="block w-64 rounded-md border border-gray-300 pl-3 pr-10 py-2 text-xs focus:border-indigo-500 focus:ring-indigo-500"
        />
      </div>

      <!-- Existing Add Button -->
      <button
        type="button"
        (click)="openModal()"
        class="inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-xs font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
      >
        Add
      </button>
    </div>
  </div>

  <!-- Table -->
  <div class="mt-8 flex flex-col">
    <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
      <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
        <div class="overflow-hidden shadow md:rounded-lg">
          <table class="min-w-full divide-y divide-gray-300">
            <thead class="bg-gray-50">
              <tr>
                <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-xs font-semibold text-gray-900 sm:pl-6">Address</th>
                <th scope="col" class="px-3 py-3.5 text-left text-xs font-semibold text-gray-900">Created at</th>
                <th scope="col" class="relative py-3.5 pl-3 pr-4 sm:pr-6">
                  <span class="sr-only">Actions</span>
                </th>
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-200 bg-white">
              <tr *ngFor="let wallet of blacklistUsdcWallets">
                <td class="whitespace-nowrap py-4 pl-4 pr-3 text-xs font-medium text-gray-900 sm:pl-6">{{ wallet.address }}</td>
                <td class="whitespace-nowrap px-3 py-4 text-xs text-gray-500">{{ wallet.created_at }}</td>
                <td class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-xs font-medium sm:pr-6">
                  <button (click)="deleteAddress(wallet.id)" class="text-indigo-600 hover:text-indigo-900">Delete</button>
                </td>
              </tr>
              <tr *ngIf="submitted || blacklistUsdcWallets.length === 0">
                <td colspan="8" class="py-6 text-center text-xs text-gray-500">
                  <ng-container *ngIf="submitted; else empty">
                    <div class="flex justify-center items-center gap-2">
                      <div class="w-5 h-5 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                      <span>Loading data...</span>
                    </div>
                  </ng-container>
                  <ng-template #empty>
                    Sorry, we couldn't find any results.
                  </ng-template>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <div class="mt-8 flex justify-center">
          <nav class="inline-flex shadow-sm rounded-md">
            <button
              (click)="goToPreviousPage()"
              [disabled]="!previousPageUrl"
              class="px-3 py-2 bg-white border border-gray-300 text-xs rounded-l-md hover:bg-gray-50 disabled:opacity-50"
            >
              ‹
            </button>
            <button
              *ngFor="let page of pageNumbers"
              (click)="page !== '...' && loadBlacklists(page)"
              [disabled]="page === '...' || currentPage === page"
              [ngClass]="{
                'bg-indigo-500 text-white': currentPage === page,
                'bg-white text-gray-700': currentPage !== page && page !== '...'
              }"
              class="px-4 py-2 border border-gray-300 text-xs"
            >
              {{ page }}
            </button>
            <button
              (click)="goToNextPage()"
              [disabled]="!nextPageUrl"
              class="px-3 py-2 bg-white border border-gray-300 text-xs rounded-r-md hover:bg-gray-50 disabled:opacity-50"
            >
            </button>
          </nav>
        </div>

      </div>
    </div>
  </div>
  <!-- Modal -->
  <div
    *ngIf="isModalOpen"
    class="fixed inset-0 z-10 flex items-center justify-center bg-black bg-opacity-50"
  >
    <div class="w-full max-w-md rounded-lg bg-white p-6 shadow-lg">
      <h2 class="text-lg font-semibold">Add New Address</h2>
      <input
        type="text"
        [(ngModel)]="newAddress"
        class="mt-4 block w-full rounded-md border border-gray-300 px-3 py-2 focus:border-indigo-500 focus:ring-indigo-500"
        placeholder="Enter address"
      />
      <div class="mt-6 flex justify-end gap-4">
        <button
          (click)="closeModal()"
          class="rounded-md border border-gray-300 bg-white px-4 py-2 text-xs font-medium text-gray-700 hover:bg-gray-50"
        >
          Cancel
        </button>
        <button
          (click)="saveAddress()"
          class="rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-xs font-medium text-white hover:bg-indigo-700"
        >
          Save
        </button>
      </div>
    </div>
  </div>
</div>
